import { EventBus } from 'quasar'

const Bus = new EventBus()
export default Bus
